function getLocalItem<T>(key: string): T | null {
  const item = sessionStorage.getItem(key);
  if (item) {
    try {
      return JSON.parse(item) as T;
    } catch (error) {
      console.error(`Error parsing data for key "${key}":`, error);
      return null;
    }
  }
  return null;
}

function setLocalItem<T>(key: string, value: T): void {
  try {
    const item = JSON.stringify(value);
    sessionStorage.setItem(key, item);
  } catch (error) {
    console.error(`Error saving data for key "${key}":`, error);
  }
}

function removeLocalItem(key: string): void {
  sessionStorage.removeItem(key);
}

function removeLocalItems(keys: string[]): void {
  keys.forEach((key) => sessionStorage.removeItem(key));
}

function hasLocalKey(key: string): boolean {
  return sessionStorage.getItem(key) !== null;
}
function clearLocal() {
  sessionStorage.clear();
}

function localStateUpdate() {
  // Проверяем, существует ли ключ в localStorage
  if (!getLocalItem("firstVisit")) {
    // Очищаем localStorage
    clearLocal();
    // Устанавливаем ключ, чтобы обозначить, что пользователь уже посетил сайт
    setLocalItem("firstVisit", true);
  }
}

export { getLocalItem, setLocalItem, removeLocalItem, hasLocalKey, clearLocal, localStateUpdate, removeLocalItems };
